import { createStore } from 'vuex'
import { initUser, share } from '@/network/api'

export default createStore({
  state: {
    isLogin: false,
    isBind: false,
    currentPage: 'Home',
    currentPop: '',
    userMsg: null,
    userName: '',
    shareURL: window.location.href
  },
  mutations: {
    setCurrentPage(state, page){
      state.currentPage = page;
    },
    setIsLogin(state, isLogin){
      state.isLogin = isLogin;
    },
    setIsBind(state, isBind){
      state.isBind = isBind;
    },
    setUserMsg(state, date){
      state.userMsg = date;
    },
    setCurrentPop(state, pop){
      state.currentPop = pop;
    }
  },
  actions: {
    updateInitUser(){
      initUser().then(res => {
        if(res.status === -1){//未登录
          
        }else if(res.status === -2){//未绑定角色
          this.commit('setIsLogin', true)
        }else if(res.status === 1){//已绑定角色
          this.commit('setUserMsg', res.result.userMsg)
          this.commit('setIsLogin', true)
          this.commit('setIsBind', true)
        }else{
          alert(res.message)
        }
      })
    }
  },
  getters: {// ==>computed
    userName(state){
      return  state.userMsg?.roleName || cookieUser?.nickName
    }
  },
  modules: {
  }
})
